var $209a46b0e01199e5$exports = {};
$209a46b0e01199e5$exports = {
    "more": `\u{414}\u{43E}\u{43F}\u{43E}\u{43B}\u{43D}\u{438}\u{442}\u{435}\u{43B}\u{44C}\u{43D}\u{44B}\u{435} \u{44D}\u{43B}\u{435}\u{43C}\u{435}\u{43D}\u{442}\u{44B}`
};


export {$209a46b0e01199e5$exports as default};
//# sourceMappingURL=ru-RU.mjs.map
